import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

const authToken = Cookies.get("authToken");
let decoded;
if (authToken){
   decoded = jwtDecode(authToken);
   console.log(decoded)
}

const initialState = {
  user:  null,
  role:  null,
  token: Cookies.get("authToken") || null,
  organizationId:  null,
  ministryId:  null,
  userId:  null,
  isAuthenticated: !!Cookies.get("authToken"),
  isLoading: false,
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      state.isLoading = false;
      state.isAuthenticated = true;
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.role = action.payload.role;
      state.organizationId = action.payload.organizationId;
      state.ministryId = action.payload.ministryId;
      state.userId = action.payload.userId;
    },
    loginFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.role = null;
      state.userId = null;
      state.user = null;
      state.token = null;
      state.organizationId=null;
      state.ministryId=null;
    },
  },
});

export const { loginStart, loginSuccess, loginFailure, logout } =
  authSlice.actions;
export default authSlice.reducer;
